import { EnvironmentUrls } from 'Roblox';
import recommendationsModule from "../recommendationsModule.js";

function recommendationsService(httpService, recommendationsConstants, thumbnailConstants) {
    "ngInject";

    function canShowRecommendationsForType(recommendationType, recommendationSubtype) {
        if (recommendationType === recommendationsConstants.recommendationTypes.bundles) {
            return true;
        }
        // do not show recommendations for Game Passes and Badges
        return recommendationSubtype > 0
            && recommendationSubtype !== recommendationsConstants.recommendationSubtypes.gamePasses
            && recommendationSubtype !== recommendationsConstants.recommendationSubtypes.badges;
    };

    function beginUpdateRecommendedItems(recommendationTargetId, recommendationType, recommendationSubtype, numItems) {
        if (recommendationType === recommendationsConstants.recommendationTypes.bundles) {
            return beginUpdateRecommendedItemsForBundle(recommendationTargetId, numItems);
        }

        var params = {
            numItems: numItems
        };

        if (recommendationTargetId > 0) {
            params.contextAssetId = recommendationTargetId;
        }

        var urlConfig = {
            url: EnvironmentUrls.inventoryApi + "/v2/recommendations/" + recommendationSubtype
        };

        return httpService.httpGet(urlConfig, params).then(
            function (result) {
                if (result && result.data) {
                    return result.data.map(translateAssetResult);
                }
            }
        );
    };

    function beginUpdateRecommendedItemsForBundle(recommendationTargetId, numItems) {
        var params = {
            numItems: numItems
        };

        var urlConfig = {
            url: EnvironmentUrls.catalogApi + "/v1/bundles/" + recommendationTargetId + "/recommendations"
        };

        return httpService.httpGet(urlConfig, params).then(
            function (result) {
                if (result && result.data) {
                    return result.data.map(translateBundleResult);
                }
                return [];
            }
        );
    };

    function getCatalogMetadata(pageName) {
        var params = {
            page: pageName
        };

        var urlConfig = {
            url: EnvironmentUrls.catalogApi + "/v1/recommendations/metadata"
        };

        return httpService.httpGet(urlConfig, params);
    };

    function translateAssetResult(result) {
        return {
            id: result.item.assetId,
            name: result.item.name,
            price: result.item.price,
            absoluteUrl: result.item.absoluteUrl,
            audioUrl: result.item.audioUrl,
            creator: {
                id: result.creator.creatorId,
                name: result.creator.name,
                type: result.creator.creatorType,
                profileLink: result.creator.creatorProfileLink
            },
            thumbnail: {
                type: thumbnailConstants.thumbnailTypes.assetThumbnail
            },
            product: {
                id: result.product.id,
                isForSale: result.product.isForSale,
                noPriceText: result.product.noPriceText,
                isFree: result.product.isFree
            }
        }
    };

    function translateBundleResult(result) {
        return {
            id: result.id,
            name: result.name,
            price: result.product.priceInRobux,
            absoluteUrl: getBundleUrl(result.id),
            audioUrl: null,
            creator: {
                id: result.creator.id,
                name: result.creator.name,
                type: result.creator.type,
                profileLink: getProfileLink(result.creator.id)
            },
            thumbnail: {
                type: thumbnailConstants.thumbnailTypes.bundleThumbnail
            },
            product: {
                id: result.product.id,
                isForSale: result.product.isForSale
            }
        }
    };

    function getBundleUrl(bundleId) {
        return EnvironmentUrls.websiteUrl + "/bundles/" + bundleId;
    };

    function getProfileLink(userId) {
        return EnvironmentUrls.websiteUrl + "/users/" + userId + "/profile";
    };

    return {
        canShowRecommendationsForType: canShowRecommendationsForType,
        beginUpdateRecommendedItems: beginUpdateRecommendedItems,
        getCatalogMetadata: getCatalogMetadata
    };
};

recommendationsModule.factory("recommendationsService", recommendationsService);
export default recommendationsService;